import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import StepRoutes from "../../../Routes/steps_routes";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";

import Pagination from "../../../Components/layouts/pagination";
import getFilteredURL from "../../../Components/Functions/filters.getUrl";
import DynamicFilterInput from "../../../Components/layouts/filter.inpit";
import DynamicFilterSelect from "../../../Components/layouts/filter.select";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcInspection } from "react-icons/fc";
import ViewWebinarChatTable from "./webinarChatTable";

const ViewWebinarChat = () => {
  const [refresh, setRefresh] = useState(false);
  const [filters, setFilters] = useState({
    startdate: "",
    enddate: "",
    webinarId: "",
    webinarAttendee: "",
  });
  const [page, setPage] = useState(1);
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [data, setData] = useState([]);
  const [webinarNames, setWebinarNames] = useState();
  const [attendeeData, setAttendeeData] = useState();
  useEffect(() => {
    performRequest(
      "GET",
      getFilteredURL(`/webinar/view-webinar-chats/`, page, filters)
    )
      .then((res) => {
        if (res.status === 201) {
          setData(res.data.allWebinarChats);
        } else {
          Toast("error", "Error while getting employee feedbacks!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, [refresh]);

  useEffect(() => {
    performRequest("GET", `/webinar/get-all-webinar`)
      .then((res) => {
        if (res.status === 200) {
          setWebinarNames(res?.data?.webinar);
        } else {
          Toast("error", "Error while getting employee feedbacks!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, [refresh]);

  useEffect(() => {
    performRequest("GET", `/webinar/get-all-webinar-purchases`)
      .then((res) => {
        if (res.status === 200) {
          setAttendeeData(res?.data);
        } else {
          Toast("error", "Error while getting employee feedbacks!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, [refresh]);

  return (
    <div className="page">
      <div className="page-wrapper">
        <div style={{ minHeight: "80vh" }}>
          <div className="page-header d-print-none">
            <div className="container-xl">
              <div className="row g-2 align-items-center">
                <div className="col">
                  <h2 className="page-title">
                    <FcInspection className="fs-2 me-1" />
                    Webinar Chats
                  </h2>
                  <h4 className="text-muted">
                    <StepRoutes />
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="container-xxl">
              <div className="row">
                <div className="col-md-3 col-sm-12 py-2">
                  <div className="card p-2">
                    <div
                      id="faq-1"
                      className="accordion"
                      role="tablist"
                      aria-multiselectable="true"
                    >
                      <div>
                        <div className="accordion-header m-0" role="tab">
                          <button
                            className="accordion-button fs-3 d-md-none p-0"
                            data-bs-toggle="collapse"
                            data-bs-target="#faq-1-1"
                          >
                            <h3 className="m-1">Filter result</h3>
                          </button>
                        </div>

                        <div
                          id="faq-1-1"
                          className="accordion-collapse collapse d-md-none"
                          role="tabpanel"
                          data-bs-parent="#faq-1"
                        >
                          <div className="accordion-body pt-0">
                            <div className="row">
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="Start Date:"
                                  value={filters.startdate}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      startdate: e.target.value,
                                    })
                                  }
                                  type="date"
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="End Date:"
                                  value={filters.enddate}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      enddate: e.target.value,
                                    })
                                  }
                                  type="date"
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Webinar Name"
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      webinarId: e.target.value,
                                    })
                                  }
                                  value={filters.webinarId}
                                >
                                  <option value="">select all</option>

                                  {webinarNames &&
                                    webinarNames.map((el) => {
                                      return (
                                        <option key={el?.id} value={el?.id}>
                                          {el?.webinarName}
                                        </option>
                                      );
                                    })}
                                </DynamicFilterSelect>
                              </div>
                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Webinar Attendee"
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      webinarAttendee: e.target.value,
                                    })
                                  }
                                  value={filters.webinarAttendee}
                                >
                                  <option value="">select all</option>

                                  {attendeeData &&
                                    attendeeData.map((el) => {
                                      return (
                                        <option key={el?.id} value={el?.name}>
                                          {el?.name}
                                        </option>
                                      );
                                    })}
                                </DynamicFilterSelect>
                              </div>

                              <div className="col-12">
                                <div className="row mt-2">
                                  <div className="col-6">
                                    <button
                                      onClick={() => setRefresh(!refresh)}
                                      className="btn btn-success w-100"
                                    >
                                      Apply Filter
                                    </button>
                                  </div>
                                  <div className="col-6">
                                    <button
                                      onClick={() => {
                                        setFilters({
                                          startdate: "",
                                          enddate: "",
                                          chatType: "",
                                        });
                                        setRefresh(!refresh);
                                      }}
                                      className="btn btn-secondary w-100"
                                    >
                                      Reset Filter
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="accordion-body d-none d-md-block">
                          <div className="row">
                            <h3>Filter result</h3>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="Start Date:"
                                value={filters.startdate}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    startdate: e.target.value,
                                  })
                                }
                                type="date"
                              />
                            </div>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="End Date:"
                                value={filters.enddate}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    enddate: e.target.value,
                                  })
                                }
                                type="date"
                              />
                            </div>
                            <div className="col-12">
                              <DynamicFilterSelect
                                label="Webinar Name"
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    webinarId: e.target.value,
                                  })
                                }
                                value={filters.webinarId}
                              >
                                <option value="">select all</option>

                                {webinarNames &&
                                  webinarNames.map((el) => {
                                    return (
                                      <option key={el?.id} value={el?.id}>
                                        {el?.webinarName}
                                      </option>
                                    );
                                  })}
                              </DynamicFilterSelect>
                            </div>
                            <div className="col-12">
                              <DynamicFilterSelect
                                label="Webinar Attendee"
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    webinarAttendee: e.target.value,
                                  })
                                }
                                value={filters.webinarAttendee}
                              >
                                <option value="">select all</option>

                                {attendeeData &&
                                  attendeeData.map((el) => {
                                    return (
                                      <option key={el?.id} value={el?.name}>
                                        {el?.name}
                                      </option>
                                    );
                                  })}
                              </DynamicFilterSelect>
                            </div>

                            <div className="col-12">
                              <div className="row mt-2">
                                <div className="col-6">
                                  <button
                                    onClick={() => setRefresh(!refresh)}
                                    className="btn btn-success w-100"
                                  >
                                    Apply Filter
                                  </button>
                                </div>
                                <div className="col-6">
                                  <button
                                    onClick={() => {
                                      setFilters({
                                        startdate: "",
                                        enddate: "",
                                        chatType: "",
                                      });
                                      setRefresh(!refresh);
                                    }}
                                    className="btn btn-secondary w-100"
                                  >
                                    Reset Filter
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-9 col-sm-12 py-2">
                  <div className="card">
                    <ViewWebinarChatTable
                      data={data}
                      currentPage={page}
                      itemsPerPage={50}
                    />
                    <Pagination
                      page={page}
                      setPage={setPage}
                      totalPages={totalPages}
                      pageDatalength={data?.allEmployeeFeedbacks?.length}
                      showPage={showPage}
                      setShowPage={setShowPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ViewWebinarChat;
